import React, { Fragment } from 'react';
import ControlledCard from '../../../../components/ControlledCard/ControlledCard';
import Grid from '@mui/material/Grid';

const StaticDisplayALevelPrograms = () => {

    const GridRow1 = () => {
        return (
            <React.Fragment>
                <Grid item xs={3}>
                    <ControlledCard avatarText="C" title="Chemistry" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="A" title="Accounting" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="S" title="Sociology" hideExpandAction hideButtonAction />
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow2 = () => {
        return (
            <React.Fragment>
                <Grid item xs={3}>
                    <ControlledCard avatarText="M" title="Mathematics" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="L" title="Literature in English" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="E" title="Environmental Management" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="G" title="Govt & Politics" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="M" title="Media Studies" hideExpandAction hideButtonAction />
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow3 = () => {
        return (
            <React.Fragment>
                <Grid item xs={3}>
                    <ControlledCard avatarText="P" title="Physics" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="E" title="Economics" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="P" title="Psychology" hideExpandAction hideButtonAction />
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow4 = () => {
        return (
            <React.Fragment>
                <Grid item xs={3}>
                    <ControlledCard avatarText="B" title="Biology" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="B" title="Bussiness" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="F" title="Fur Maths" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="H" title="History" hideExpandAction hideButtonAction />
                </Grid>
            </React.Fragment>
        );
    }

    const GridRow5 = () => {
        return (
            <React.Fragment>
                <Grid item xs={3}>
                    <ControlledCard avatarText="U" title="Urdu" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="G" title="General Paper" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="E" title="English Language" hideExpandAction hideButtonAction />
                </Grid>
                <Grid item xs={3}>
                    <ControlledCard avatarText="T" title="Thinking Skills" hideExpandAction hideButtonAction />
                </Grid>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <div style={{
                paddingBottom: 10, width: '90%',
                marginLeft: '4%', paddingTop: 10
            }}>
                <center>
                    <Grid container spacing={2}>
                        <Grid style={{
                            fontSize: 22,
                            textAlign: 'left',
                            color: '#174a84'
                        }} xs={12}>
                            Group 1
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            <GridRow1 />
                        </Grid>
                        <Grid style={{
                            fontSize: 22,
                            textAlign: 'left',
                            color: '#174a84'
                        }} xs={12}>
                            Group 2
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            <GridRow2 />
                        </Grid>
                        <Grid style={{
                            fontSize: 22,
                            textAlign: 'left',
                            color: '#174a84'
                        }} xs={12}>
                            Group 3
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            <GridRow3 />
                        </Grid>
                        <Grid style={{
                            fontSize: 22,
                            textAlign: 'left',
                            color: '#174a84'
                        }} xs={12}>
                            Group 4
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            <GridRow4 />
                        </Grid>
                        <Grid style={{
                            fontSize: 22,
                            textAlign: 'left',
                            color: '#174a84'
                        }} xs={12}>
                            Group 5
                        </Grid>
                        <Grid container item xs={12} spacing={2}>
                            <GridRow5 />
                        </Grid>
                    </Grid>
                    <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                        <strong>NOTE:</strong>  A subject is taught if at least six students are enrolled at the time of admission.
                    </div>
                </center>
            </div >
        </Fragment>
    );
}

export default StaticDisplayALevelPrograms;